import { defineStore } from "pinia";
import { institution_actions, institution_getters, institution_state } from "./institution";
import { group_actions, group_getters, group_state } from "./group";
import { relations_actions, relations_getters, relations_state } from "./relations";
import { confidentialFolder_actions, confidentialFolder_getters, confidential_state } from "./confidentialFolder";
import { peolpe_getters, people_actions, people_state } from "./people";

export const usePeopleStore = defineStore("people", {
  state: () => Object.assign({}, institution_state, relations_state, confidential_state, people_state, group_state),
  actions: Object.assign(
    {},
    institution_actions,
    relations_actions,
    confidentialFolder_actions,
    people_actions,
    group_actions
  ),
  getters: Object.assign(
    {},
    institution_getters,
    relations_getters,
    confidentialFolder_getters,
    peolpe_getters,
    group_getters
  )
});
